import React from 'react';

const Loader = () => {
  return (
    <div className="modern-loader-container">
      <div className="modern-spinner">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>
    </div>
  );
};

export default Loader;
